module.exports = __webpack_public_path__ + "static/media/270781643703779banner1.416c05d0.jpg";